module.exports = __webpack_public_path__ + "img/UpstreamNZ_Charitable_Contribution_how_it_is_divided.07d42913.png";